import { render, staticRenderFns } from "./answer-history.vue?vue&type=template&id=c14da056&scoped=true"
import script from "./answer-history.vue?vue&type=script&lang=js"
export * from "./answer-history.vue?vue&type=script&lang=js"
import style0 from "./answer-history.vue?vue&type=style&index=0&id=c14da056&prod&lang=less&scoped=true"
import style1 from "./answer-history.vue?vue&type=style&index=1&id=c14da056&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14da056",
  null
  
)

export default component.exports